module.exports = __webpack_public_path__ + "static/img/guide2.6074a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guide2.png
// module id = LEH4
// module chunks = 0